import { MetaDataItem } from '../types'

export const METADATA_DATA_ITEMS: MetaDataItem[] = [
  {
    number: 1,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Nomor Pokok Satuan Pendidikan Nasional (NPSN)',
    alias: 'Nomor Pokok Satuan Pendidikan Nasional (NPSN)',
    definition:
      'Kode referensi berbentuk nomor unik bagi satuan pendidikan yang berfungsi sebagai nomor identitas satuan pendidikan.',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Format 8 (delapan) digit yang terdiri atas kombinasi huruf dan/atau angka',
      'Valid berdasarkan mekanisme verifikasi dan validasi sesuai peraturan perundang-undangan',
    ],
    question:
      'Nomor Pokok Satuan Pendidikan Nasional (NPSN) dari Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 2,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identias',
    variable: 'Nomor Surat Keputusan Izin Pendirian',
    alias: 'Nomor SK Izin Pendirian',
    definition: 'Nomor Surat Keputusan Izin Pendirian Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid berdasarkan mekanisme verifikasi dan validasi sesuai peraturan perundang-undangan',
    ],
    question: 'Nomor SK Izin Pendirian',
    isPublic: true,
  },
  {
    number: 3,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Nama Satuan Pendidikan',
    alias: 'Nama Satuan Pendidikan',
    definition:
      'Nama satuan pendidikan berdasarkan izin pendirian Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Teks bebas dengan panjang maksimal 100 (seratus) karakter',
      'Valid sesuai dengan izin pendirian Satuan Pendidikan',
    ],
    question: 'Nama Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 4,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Jalur Pendidikan',
    alias: 'Jalur Pendidikan',
    definition:
      'Wahana yang dilalui peserta didik untuk mengembangkan potensi diri dalam suatu proses pendidikan yang sesuai dengan tujuan pendidikan.',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jalur pendidikan',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Jalur Pendidikan Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 5,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Jenjang Pendidikan',
    alias: 'Jenjang Pendidikan',
    definition:
      'Tahapan pendidikan yang ditetapkan berdasarkan tingkat perkembangan peserta didik, tujuan yang akan dicapai, dan kemampuan yang dikembangkan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jenjang pendidikan',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Jenjang Pendidikan Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 6,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Jenis Pendidikan',
    alias: 'Jenis Pendidikan',
    definition:
      'Kelompok yang didasarkan pada kekhususan\ntujuan pendidikan suatu satuan pendidikan.',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jenis pendidikan',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Jenis Pendidikan untuk Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 7,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Program Pendidikan',
    alias: 'Program Pendidikan',
    definition:
      'Program pendidikan yang diselenggarakan oleh satuan pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: program pendidikan',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Program pendidikan yang diselenggarakan oleh satuan pendidikan',
    isPublic: true,
  },
  {
    number: 8,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Kementerian atau Lembaga Pembina Satuan Pendidikan',
    alias: 'Kementerian atau Lembaga Pembina Satuan Pendidikan',
    definition:
      'Kementerian atau kementerian/lembaga lain yang membina satuan pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Sesuai dengan nama kementerian yang membina satuan pendidikan',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question:
      'Kementerian atau kementerian/lembaga lain yang membina satuan pendidikan',
    isPublic: true,
  },
  {
    number: 9,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Status Satuan Pendidikan',
    alias: 'Status Satuan Pendidikan',
    definition: 'Status penyelenggaraan Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: status satuan pendidikan',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Status Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 10,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Nama Jalan',
    alias: 'Nama Jalan',
    definition: 'Nama jalan atau jalan raya lokasi Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Nama Jalan tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 11,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Rukun Tetangga',
    alias: 'RT',
    definition: 'Nomor Rukun Tetangga lokasi Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      '3 (tiga) digit angka',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'RT tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 12,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Rukun Warga',
    alias: 'RW',
    definition: 'Nomor Rukun Warga lokasi Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      '3 (tiga) digit angka',
      'Valid sesuai izin pendirian satuan pendidikan',
    ],
    question: 'RW tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 13,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Dusun',
    alias: 'Dusun',
    definition: 'Nama dusun/lingkungan lokasi Satuan Pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid sesuai izin pendirian satuan pendidikan',
    ],
    question: 'Dusun tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 14,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Kelurahan/Desa',
    alias: 'Kelurahan/Desa',
    definition:
      'Nama Kelurahan/Desa lokasi Satuan Pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Kode kelurahan/desa berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Kelurahan/Desa tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 15,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Kecamatan',
    alias: 'Kecamatan',
    definition:
      'Nama kecamatan sesuai dengan lokasi satuan pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Kode kecamatan berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Kecamatan tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 16,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Kabupaten/Kota',
    alias: 'Kabupaten/Kota',
    definition:
      'Nama kabupaten/kota sesuai dengan lokasi Satuan Pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Kode kabupaten/kota berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Kabupaten/Kota tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 17,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Provinsi',
    alias: 'Provinsi',
    definition:
      'Nama provinsi sesuai dengan lokasi Satuan Pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification:
      'Kode provinsi berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format yang sesuai dengan klasifikasi isian',
      'Valid sesuai dengan izin pendirian satuan pendidikan',
    ],
    question: 'Provinsi tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 18,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Kode Pos',
    alias: 'Kode Pos',
    definition:
      'Nomor angka yang menunjukkan kode dari sebuah area, berdasarkan data yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang komunikasi dan informatika',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Peraturan Menteri tentang Sistem Kode Pos',
    validationRules: [
      '5 (lima) digit angka',
      'Tidak boleh kosong',
      'Valid sesuai dengan kode pos yang tercantum pada surat penetapan/keputusan pengesahan badan hukum dari Kementerian Hukum dan HAM',
    ],
    question: 'Kode Pos tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 19,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Lintang',
    alias: 'Lintang',
    definition:
      'Garis khayal yang digunakan untuk menentukan lokasi di Bumi yang berpusat pada garis khatulistiGaris lintang yang melingkari bumi dari bagian ekuator hingga ke bagian kutub utara dan bagian kutub selatan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'Geospatial',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid sesuai dengan format lintang pada SNI ISO tentang Metadata Spasial<sup>*</sup>',
    ],
    question: 'Lintang koordinat tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 20,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Alamat',
    variable: 'Bujur',
    alias: 'Bujur',
    definition:
      'Garis khayal yang ditarik dari kutub utara hingga ke kutub selatan untuk menentukan lokasi di bumi pada globe atau peta',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'Geospatial',
    inputClassification: '-',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid sesuai dengan format bujur pada SNI ISO tentang Metadata Spasial<sup>**</sup>',
    ],
    question: 'Bujur koordinat tempat Satuan Pendidikan',
    isPublic: true,
  },
  {
    number: 21,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Identitas',
    variable: 'Citra',
    alias: 'Citra',
    definition: 'Gambar dari satuan pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: ['Isian Tidak Boleh Kosong'],
    question: 'Gambar satuan pendidikan',
    isPublic: true,
  },
  {
    number: 22,
    objectClass: 'Satuan Pendidikan',
    objectSubClass: 'Badan Penyelenggara Satuan Pendidikan',
    variable: 'Nomor Pokok Badan Penyelenggara Satuan Pendidikan (NPBP)',
    alias: 'Nomor Pokok Badan Penyelenggara Satuan Pendidikan (NPBP)',
    definition:
      'Kode referensi berbentuk nomor unik bagi badan penyelenggara satuan pendidikan yang menaungi satuan pendidikan yang berfungsi sebagai nomor identitas badan penyelenggara satuan pendidikan.',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: '-',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Format 6 (enam) digit terdiri dari kombinasi huruf dan/atau angka',
      'Valid sesuai dengan surat penetapan/keputusan pengesahan badan hukum dari Kementerian Hukum dan HAM',
    ],
    question:
      'Nomor Pokok Badan Penyelenggara Satuan Pendidikan (NPBP) dari Badan Penyelenggara Satuan Pendidikan yang menaungi Satuan Pendidikan',
    isPublic: true,
  },
]
